/**
 * 退出登录后统一回到首页并刷新，保证导航栏 / 各页用户态一致。
 * 任意页面调用方需先 clearUser、removeItem('user') 再调用本函数。
 */
export function goHomeAfterLogout(router) {
  if (!router) return
  router.push({ name: 'Home' }).catch(() => {})
  window.setTimeout(() => {
    window.location.reload()
  }, 100)
}
